import { controlServiceImpl } from "@lvt/streaming";
import { List, ListItem, ListItemText, ListItemIcon, Container, makeStyles } from "@material-ui/core";
import PlayIcon from "@material-ui/icons/PlayCircleFilled";
import Lottie from "lottie-react";
import { useState } from "react";

import client from "@/api/client";
import { SpeakerSound } from "@/api/streamMetadata/types";
import soundWaveAnimation from "@/assets/animations/soundwave.json";
import * as FullStory from "@/utilities/hooks/fullstory";


interface QuickSoundsProps {
    sounds: SpeakerSound[];
    cameraId: number;
    onError?: (error: any) => void;
}

const useStyles = makeStyles((theme) => ({
    listItem: {
        "&:hover": {
            backgroundColor: theme.palette.primary.light,
        },
    },
    playIcon: {
        fill: theme.palette.primary.contrastText,
    },
    soundAnimation: {
        width: 24,
        marginLeft: 8,
    },
    iconArea: {
        position: "absolute",
        right: 0,
    },
    list: {
        maxHeight: 400,
        overflowY: "auto",
    },
}));

const QuickSounds: React.FC<QuickSoundsProps> = ({ sounds, cameraId, onError }) => {
    const styles = useStyles();

    const [playingId, setPlayingId] = useState<null | number>(null);

    const controlService = controlServiceImpl(client, cameraId);

    const handleClick = async (sound: SpeakerSound) => {
        setPlayingId(sound.id);

        try {
            await controlService.speakerSound(sound.id);
        } catch (e: any) {
            // TODO: Put back when edge stops returning errors every time
            // setPlayingId(null);

            if (onError) {
                onError(e.message);
            }
        }
    };

    return (
        <List classes={{ root: styles.list }}>
            {sounds.map((sound) => (
                <ListItem
                    key={sound.id}
                    button
                    onClick={() => handleClick(sound)}
                    classes={{ root: styles.listItem }}
                    disabled={playingId !== null && playingId !== sound.id}
                    title="Play Sound"
                    className={FullStory.names.classes.streaming.quickSound}
                >
                    <ListItemText>{sound.label}</ListItemText>
                    <ListItemIcon classes={{ root: styles.iconArea }}>
                        {playingId !== sound.id ? (
                            <Container title="Sound Icon">
                                <PlayIcon classes={{ root: styles.playIcon }} />
                            </Container>
                        ) : (
                            <Lottie
                                animationData={soundWaveAnimation}
                                title="Quick Sound Playing"
                                loop={false}
                                onComplete={() => {
                                    setPlayingId(null);
                                }}
                                className={styles.soundAnimation}
                            />
                        )}
                    </ListItemIcon>
                </ListItem>
            ))}
        </List>
    );
};

export default QuickSounds;
